import { ref, onMounted, onUnmounted } from 'vue';

// Keeps embedded CRM iframes (Kanban, Integracoes, Configuracoes IA) in sync
// with Chatwoot's own theme, so switching Chatwoot's theme is the only
// action needed -- no separate toggle inside the CRM.
export function useCrmEmbedTheme() {
  const theme = ref('light');
  let observer;

  const detectTheme = () => {
    const className = `${document.documentElement.className} ${document.body.className}`.toLowerCase();
    theme.value = className.includes('dark') ? 'dark' : 'light';
  };

  onMounted(() => {
    detectTheme();
    observer = new MutationObserver(detectTheme);
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class', 'data-theme'],
    });
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'data-theme'],
    });
  });

  onUnmounted(() => {
    observer?.disconnect();
  });

  return { theme };
}
